import React from 'react';
import { mergeClassnames } from '../../utils/mergeClassnames';
import { Padding } from '../../view-model/Spacing';
import { BorderRadius } from '../../view-model/BorderRadius';
import { BgColor } from '../../view-model/Colors';

interface CardProps {
  borderRadius: BorderRadius;
  padding: Padding;
  children: React.ReactNode;
  id?: string;
  background_color?: BgColor;
}

function Card({
  borderRadius,
  padding,
  children,
  id,
  background_color,
}: Readonly<CardProps>): React.ReactElement {
  const classNames = mergeClassnames(
    background_color ?? 'bg-qneutral-5',
    borderRadius,
    padding,
  );

  return (
    <div id={id} className={classNames}>
      {children}
    </div>
  );
}

export default Card;
